// init/components.js
// 只注册高频公共组件；业务页面自己按需 import，避免进入主 chunk
import Container from '../components/container/Container.vue';
import ExportDialog from '../components/container/ExportDialog.vue';
import FormDbItem from '../components/form/FormDbItem.vue';
import FormDictItem from '../components/form/FormDictItem.vue';
import FormEditItem from '../components/form/FormEditItem.vue';
import FormFileItem from '../components/form/FormFileItem.vue';
import FormImageItem from '../components/form/FormImageItem.vue';
import FormMapItem from '../components/form/FormMapItem.vue';

const whitelist = {
  Container,
  ExportDialog,
  FormDbItem,
  FormDictItem,
  FormEditItem,
  FormFileItem,
  FormImageItem,
  FormMapItem,
};

export default {
  install(app) {
    for (const name in whitelist) {
      app.component(name, whitelist[name]);
    }
  },
};